// Card chrome shared by the stats page and the cards it pulls out into their own
// components (ByPersonCard). Presentation only — no data, no state.

export function Card({ children }) {
  return (
    <div className="border rounded-lg p-5" style={{ backgroundColor: '#0d1b2e', borderColor: '#1e3a5f' }}>
      {children}
    </div>
  );
}

export function Label({ children }) {
  return <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">{children}</p>;
}
